import React, {
  useReducer,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import { Route, Switch, useRouteMatch, useHistory } from "react-router-dom";

import {
  getListAllAPI,
  getSessionId,
  api,
  getUuidVendaRascunho,
  setUuidVendaRascunho,
  getVendaRascunho,
  salvarVendaRascunho,
} from "../../services";
import { CLIENTE_DEFAULT, INCLUIR_TOKEN_TLS_FISERV } from "../../utils";
import InicioFrenteCaixaVenda from "./_SubPages/Itens";
import FinalizarFrenteCaixaVenda from "./_SubPages/Parcelas";
import { VendaContext } from "./context";
import reducer from "./reducer";
import { Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import getInterfaceSitef from "../../services/sitef/interface";
import { AppContext } from "../../app/context";

const tempoPing = 5 * 1000;

const CreateVenda = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [venda, dispatch] = useReducer(reducer, {
    cliente: null,
    itens: [],
    itensExcluidos: [],
    parcelas: [],
    idEdit: -1,
    isEditPrice: false,
    tipoVenda: 0,
    isEmPartes: false,
    uuid: null,
    revenda: false,
  });

  const deveCarregarVendaSalvaRef = useRef(
    Boolean(history.location.state && history.location.state.carregarVendaSalva)
  );

  const { path } = useRouteMatch();
  const refCont = useRef(0);
  const { app } = useContext(AppContext);

  const {
    IdTerminalSitef,
    IPSiTef,
    IdLoja,
    cnpjAC,
    cnpjEstabelecimento,
    tokenTlsFiserv,
    usar_tef,
    interfaceSitef
  } = app;

  const [tefConferido, setTefConferido] = useState(false);

  async function getUuid() {
    try {
      const data = await api.get("/generate-uuid");
      dispatch({ type: "UPDATE_UUID", uuid: data.data.uuid });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO GERAR UUID", {
        variant: "error",
      });
    }
  }

  async function carregarVendaSalva() {
    const uuid = getUuidVendaRascunho();

    if (!uuid) {
      return false;
    }

    try {
      const data = await getVendaRascunho(uuid);

      if (data.status) {
        dispatch({ type: "CARREGAR_VENDA_SALVA", venda: data.data });
        setUuidVendaRascunho(null);
        return true;
      }

      enqueueSnackbar(data.message || "Não foi possível carregar a venda salva!", {
        variant: "error",
      });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO CARREGAR A VENDA SALVA", {
        variant: "error",
      });
    }

    setUuidVendaRascunho(null);
    return false;
  }

  useEffect(() => {
    async function inicializar() {
      const carregou = deveCarregarVendaSalvaRef.current
        ? await carregarVendaSalva()
        : false;

      if (!carregou) {
        getUuid();
        getDefaults();
        getDadosFiscaisSitef();
      }
    }

    inicializar();
  }, []);

  async function verifyState() {
    if(!usar_tef) {
      setTefConferido(true);
      return;
    }

    if(usar_tef) {
      const state = await interfaceSitef.getState();

      if (state.serviceStatus !== 0) {
        enqueueSnackbar("AgenteCliSiTef indisponível.", {
          variant: "error",
        });
        irParaTelaInit()
        return;
      }
      
      switch (state.serviceState) {
        case 0: {
          enqueueSnackbar("Agente não inicializado.", {
            variant: "error",
          });
          irParaTelaInit()
          return;
          break;
        }
        case 1: {
          break;
        }
        case 2: {
          enqueueSnackbar("IniciaFuncaoSiTefInterativo iniciado com sucesso; aguardando chamada clisitef/continueTransaction", {
            variant: "error",
          });
          irParaTelaInit()
          return;
          break;
        }
        case 3: {
          enqueueSnackbar("processo iterativo da CliSiTef em andamento; aguardando chamada clisitef/continueTransaction.", {
            variant: "error",
          });
          irParaTelaInit()
          return;
          break;
        }
        case 4: {
          enqueueSnackbar("aguardando clisitef/finishTransaction.", {
            variant: "error",
          });
          irParaTelaInit()
          return;
          break;
        }
        default: {
          enqueueSnackbar("TEF erro não catalogado", {
            variant: "error",
          });
          irParaTelaInit()
          return;
          break;
        }
      }

      const statePinPad = await interfaceSitef.getStatePinPad(interfaceSitef.getSessionId());

      if (statePinPad.serviceStatus !== 0) {
        enqueueSnackbar(`Erro Pinpad: ${statePinPad.serviceMessage}`, {
          variant: "error",
        });
        irParaTelaInit()
        return;
      }

      if (!statePinPad.clisitefStatus) {
        enqueueSnackbar(`PinPad não presente`, {
          variant: "error",
        });
        irParaTelaInit()
        return;
      }

      setTefConferido(true);
    }
  }

  useEffect(() => {
    verifyState()
  }, []);

  async function getDefaults() {
    try {
      const dataClientes = await getListAllAPI(
        "clientes",
        ["id", "asc"],
        { nome: CLIENTE_DEFAULT },
        ["cidade.estado", "categoria"]
      );

      dispatch({ type: "UPDATE_CLIENTE", cliente: dataClientes.data[0] });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO BUSCAR O CLIENTE ANÔNIMO", {
        variant: "error",
      });
    }
  }

  useEffect(() => {
    const timer = setInterval(() => {
      getDados();
      refCont.current = 1;
    }, tempoPing);
    return () => clearInterval(timer);
  });

  async function getDados() {
    if (refCont.current) {
      if (!venda.cliente) {
        await getDefaults();
      }
      if (!venda.uuid) {
        await getUuid();
      }
      if (!venda.CupomFiscal) {
        await getDadosFiscaisSitef();
      }
    }
  }

  async function getDadosFiscaisSitef() {
    try {
      const data = await api.get("/gerar-cumpom-fiscal-sitef");
      dispatch({
        type: "UPDATE_DADOS_SITEF",
        CupomFiscal: data.data.cupom,
        DataFiscal: data.data.data,
      });
    } catch (e) {
      enqueueSnackbar("INTERNET: ERRO AO GERAR DADOS FISCAIS", {
        variant: "error",
      });
    }
  }

  const refDebounceRascunho = useRef(null);

  useEffect(() => {
    if (venda.idEdit > 0 || !venda.uuid || !venda.itens || venda.itens.length === 0) {
      return;
    }

    if (refDebounceRascunho.current) {
      clearTimeout(refDebounceRascunho.current);
    }

    // o rascunho guarda só os itens (carrinho); parcelas nunca são salvas:
    // se algo der errado, o pagamento deve recomeçar do zero
    const vendaParaSalvar = {
      cliente: venda.cliente,
      itens: venda.itens,
      itensExcluidos: venda.itensExcluidos,
      cpf: venda.cpf,
      cnpj: venda.cnpj,
      tipoNota: venda.tipoNota,
      revenda: venda.revenda,
      tipoVenda: venda.tipoVenda,
      isEmPartes: venda.isEmPartes,
      uuid: venda.uuid,
      idEdit: venda.idEdit,
      CupomFiscal: venda.CupomFiscal,
      DataFiscal: venda.DataFiscal,
    };

    refDebounceRascunho.current = setTimeout(() => {
      salvarVendaRascunho(venda.uuid, vendaParaSalvar)
        .then(() => setUuidVendaRascunho(venda.uuid))
        .catch(() => {});
    }, 4000);

    return () => clearTimeout(refDebounceRascunho.current);
  }, [
    venda.idEdit,
    venda.uuid,
    venda.itens,
    venda.itensExcluidos,
    venda.cliente,
    venda.cpf,
    venda.cnpj,
    venda.tipoNota,
    venda.revenda,
    venda.tipoVenda,
    venda.isEmPartes,
  ]);

  function irParaTelaInit() {
    history.push("/");
  }

  function irParaTelaFinalizarVenda() {
    history.push("/vendas/finalizarvenda");
  }

  function irParaTelaFrentedeCaixa() {
    history.push("/vendas/frentedecaixa");
  }

  return (
    <>
      {venda.cliente && venda.uuid && venda.CupomFiscal && ( usar_tef ? interfaceSitef : true) && tefConferido ? (
        <VendaContext.Provider value={{ venda, dispatch }}>
          <Switch>
            <Route
              path={`${path}/frentedecaixa`}
              render={(props) => (
                <InicioFrenteCaixaVenda
                  irParaTelaInit={irParaTelaInit}
                  irParaTelaFinalizarVenda={irParaTelaFinalizarVenda}
                />
              )}
            />
            <Route
              path={`${path}/finalizarvenda`}
              render={(props) => (
                <FinalizarFrenteCaixaVenda
                  irParaTelaInit={irParaTelaInit}
                  irParaTelaFrentedeCaixa={irParaTelaFrentedeCaixa}
                  getSessionId={() => getSessionId()}
                />
              )}
            />
          </Switch>
        </VendaContext.Provider>
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
            fontSize: "40px",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          Inicializando a Venda...
          <Button
            onClick={irParaTelaInit}
            color="secondary"
            variant="contained"
            autoFocus
          >
            {`Voltar Para a Tela Inicial`}
          </Button>
        </div>
      )}
    </>
  );
};

export default CreateVenda;
